import formatDate from '../utils/formatDate'

export const myMixin = {
  methods: {
    // 跳转路由
    go(route) {
      this.$router.push({ name: route })
    },
    // 打开新的页面
    newPage(url) {
      window.open(url, '_blank')
    },
    // 多级数组查询对象
    findMix(arr, name) {
      if (arr == null) return null
      for (const obj of arr) {
        if (obj.id === name) {
          return this.collect(obj)
        }
        const ret = this.findMix(obj.children, name)
        if (ret) return ret
      }
      return null
    },
    collect(obj) {
      let ret = obj
      if (obj.children) {
        for (const o of obj.children) {
          ret = [...ret, ...this.collect(o)]
        }
      }
      return ret
    },
    arrGetName(arr) {
      const length = arr.length
      for (let i = 0; i < length; i++) {
        arr[i].name = arr[i].id
      }
      return arr
    },
    // 补零操作
    addZero(num) {
      if (parseInt(num, 10) < 10) {
        num = '0' + num
      }
      return num
    }
  },
  computed: {
    br() {
      return function (context) {
        if (context) {
          return context.replace(/\n/g, '<br>')
        }
      }
    },
    dataConvert() {
      return function (timestamp) {
        return formatDate(timestamp)
      }
    },
    timeChange() {
      return function (time) {
        return formatDate(time)
      }
    }
  }
}
